import { idcMap } from "./idcMap";
import { paginationMap } from "./pagination";

export const paginatedIdcsMap: GenericObject = {
	results: idcMap,
	...paginationMap,
};
